var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    _vm._l(Object.entries(_vm.configuration), function ([key, value]) {
      return _c(
        "v-layout",
        { key: key, staticClass: "py-1", attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { md4: "", sm12: "" } }, [
            _c("b", [
              _vm._v(_vm._s(_vm.capitalize(_vm.spaceBeforeCapital(key)))),
            ]),
            _vm._v(":\n    "),
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticStyle: { "max-height": "200px", overflow: "auto" },
              attrs: { md8: "", sm12: "" },
            },
            [key != "password" ? [_vm._v(_vm._s(value))] : [_vm._v("*****")]],
            2
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }